export default {"src":"/_next/static/media/arrow-bottom.4a72ea37.svg","height":7,"width":14,"blurWidth":0,"blurHeight":0};